import { render, staticRenderFns } from "./SchoolConfigAttendanceEmployee.vue?vue&type=template&id=336a7cc8&scoped=true"
import script from "./SchoolConfigAttendanceEmployee.vue?vue&type=script&lang=js"
export * from "./SchoolConfigAttendanceEmployee.vue?vue&type=script&lang=js"
import style0 from "./SchoolConfigAttendanceEmployee.vue?vue&type=style&index=0&id=336a7cc8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336a7cc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('336a7cc8')) {
      api.createRecord('336a7cc8', component.options)
    } else {
      api.reload('336a7cc8', component.options)
    }
    module.hot.accept("./SchoolConfigAttendanceEmployee.vue?vue&type=template&id=336a7cc8&scoped=true", function () {
      api.rerender('336a7cc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/SchoolConfigAttendanceEmployee.vue"
export default component.exports